import { isFunction } from '../types/function.js';
import * as React from 'react';
import { useRef, useState, useEffect, useCallback } from 'react';
import { Chevron, List, ListElement, Container, SelectedItem, Placeholder, ItemText, IconWrap } from './styles.js';
import { useOverrides } from '../hooks/useOverrides/useOverrides.js';

const defaultComponents = {
    List: List,
    ListElement: ListElement,
    Container: Container,
    SelectedItem: SelectedItem,
    Placeholder: Placeholder,
    ItemText: ItemText,
    IconWrap: IconWrap
};
const DefaultProps = {
    overrides: {},
    onChange: ()=>void 0,
    onClose: ()=>void 0,
    onOpen: ()=>void 0,
    options: []
};
const DropDown = ({ className , defaultValue , placeholder , options =DefaultProps.options , onOpen =DefaultProps.onOpen , onChange =DefaultProps.onChange , onClose =DefaultProps.onClose , overrides =DefaultProps.overrides  })=>{
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const isMultiple = Array.isArray(options) && options.length > 1;
    const [selectedValue, setSelectedValue] = useState(null);
    useEffect(()=>{
        if (defaultValue && isMultiple) {
            const findedOption = options.find((o)=>o.value === defaultValue.value && o.label === defaultValue.label) || null;
            setSelectedValue(findedOption);
        } else if (options.length === 1) {
            setSelectedValue(options[0]);
        } else {
            setSelectedValue(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultValue,
        isMultiple
    ]);
    const handleOpen = useCallback(()=>{
        setIsOpen(true);
        if (onOpen && isFunction(onOpen)) {
            onOpen();
        }
    }, [
        onOpen
    ]);
    const handleClose = useCallback(()=>{
        setIsOpen(false);
        if (onClose && isFunction(onClose)) {
            onClose();
        }
    }, [
        onClose
    ]);
    const getChangeCallback = useCallback((element)=>()=>{
            setSelectedValue(element);
            if (onChange && isFunction(onChange)) {
                onChange(element);
            }
            handleClose();
        }, [
        handleClose,
        onChange
    ]);
    const handleClickOutside = useCallback((event)=>{
        if (event && rootRef && rootRef.current && !rootRef.current.contains(event.target) && isOpen) {
            handleClose();
        }
    }, [
        handleClose,
        isOpen
    ]);
    const { Container: { component: Container  } , List: { component: List  } , ListElement: { component: ListElement  } , SelectedItem: { component: SelectedItem  } , Placeholder: { component: Placeholder  } , ItemText: { component: ItemText  } , IconWrap: { component: IconWrap  }  } = useOverrides(defaultComponents, overrides);
    useEffect(()=>{
        if (!isMultiple) {
            return ()=>null;
        }
        window.addEventListener("click", handleClickOutside, true);
        return function cleanup() {
            window.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        handleClickOutside,
        isMultiple
    ]);
    return /*#__PURE__*/ React.createElement(Container, {
        className: className,
        "data-testid": "dropdown-root-test-id",
        ref: rootRef
    }, /*#__PURE__*/ React.createElement(SelectedItem, {
        onClick: isMultiple ? handleOpen : null,
        "data-testid": "dropdown-selected-item-test-id",
        isMultiple: isMultiple
    }, selectedValue && selectedValue.icon && /*#__PURE__*/ React.createElement(IconWrap, null, selectedValue.icon), /*#__PURE__*/ React.createElement(ItemText, null, selectedValue && selectedValue.label, !selectedValue && placeholder && /*#__PURE__*/ React.createElement(Placeholder, null, placeholder)), isMultiple && /*#__PURE__*/ React.createElement(Chevron, null)), isMultiple && /*#__PURE__*/ React.createElement(List, {
        isOpen: isOpen,
        "data-testid": "dropdown-list-test-id"
    }, options.map((o)=>/*#__PURE__*/ React.createElement(ListElement, {
            key: o.label + o.value,
            onClick: getChangeCallback(o)
        }, o.icon && /*#__PURE__*/ React.createElement(IconWrap, null, o.icon), /*#__PURE__*/ React.createElement(ItemText, null, o.label)))));
};

export { DropDown };
